import {Component, Input} from '@angular/core';
import {Room} from '../shared/Room';

@Component({
    selector: 'edu-udo-itmc-dev-mini-book-room-display',
    templateUrl: './room-display.component.html',
    styleUrls: ['./room-display.component.css'],
    standalone: false
})
export class RoomDisplayComponent {

  @Input()
  room: Room | undefined;
  @Input()
  online: boolean | undefined;

}
